export enum TransactionDirection {
    DEBIT = 'debit',
    CREDIT = 'credit'
}
